import { Link, Typography as Text } from '@material-ui/core';

import { RiExternalLinkLine } from '@remixicon/react';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import { isSafeUrl } from '@spotify/plugin-confidence-artifacts-react';

import styles from './ExternalUrlArtifactContent.module.css';

interface ExternalUrlArtifactContentProps {
  artifact: AttachmentFragment;
  // Optional UI URL. Omit when the artifact has no navigable UI.
  href?: string;
  onOpen?: () => void;
  title?: string;
  fallbackTitle?: (artifact: AttachmentFragment) => string;
}

const defaultFallbackTitle = (artifact: AttachmentFragment) => artifact.uri;

export const ExternalUrlArtifactContent = ({
  artifact,
  href,
  onOpen,
  title,
  fallbackTitle = defaultFallbackTitle,
}: ExternalUrlArtifactContentProps) => {
  const label = title || artifact.displayName || fallbackTitle(artifact);
  const safeUrl = href && isSafeUrl(href) ? href : undefined;

  const renderContent = () => {
    if (onOpen) {
      return (
        <Link component="button" onClick={onOpen} className={styles.link}>
          {label}
        </Link>
      );
    }
    if (safeUrl) {
      return (
        <Link
          href={safeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
        >
          {label}
          <RiExternalLinkLine size={14} />
        </Link>
      );
    }
    return <Text variant="body1">{label}</Text>;
  };

  return <div className={styles.info}>{renderContent()}</div>;
};
